<template>
  <div>
    <section class="xieyi">
        <header>
            <h3>用户隐私政策概要</h3>
        </header>
        <div class="info">
            <p>欢迎使用 有影 ！ 我们将按照法律法规要求，严格的安全保护措施，保护您的个人隐私信息。</p>
            <p>1. 在您使用我方提供的服务时，请您认真阅读并了解 <span @click="openTk" class="tiaokuan">《隐私条款》</span>，详细了解我方收集存储、使用、披露和保护您的个人信息的举措，进而帮助您更多地保护您的隐私。</p>
            <p>2. 为了向您提供音视频服务、收藏订阅评论互动等服务，我们需要收集您的观看历史、设备信息、操作日志等个人信息。</p>
            <p>3. 您可以在设置页面或者联系客服，更正或删除您的个人信息并管理您的授权。</p>
            <p>4. 我们会采取业界领先的安全技术保护好您的个人信息。</p>
        </div>
        <footer>
            <span class="small">点击 “同意” 即表示您已阅读并同意全部条款</span>
            <div @click="TAgree(0)">不同意并退出APP</div>  <div class="active" @click="TAgree(1)"><span>同意</span></div>
        </footer>
    </section>
  </div>
</template>
<script>
export default {
    methods : {
        openTk() {
            // console.log(this.$yymd.OpenURL)
            // console.log(location.origin + '/about/details/3');
            this.$yymd.OpenURL(location.origin + '/about/details/3');
        },
        TAgree(agree) {
            this.$yymd.TAgree(agree);
        }
    },
}
</script>
<style lang="less">
html,body,#app{
    background-color: transparent !important;
}
#app {
    background-color: rgba(0,0,0,0) !important;
}

.xieyi {
    position:fixed;
    z-index: 1000;
    top:50%; left:10%;
    width:80%;
    transform: translateY(-50%);
    background-color:#fff;
    color: #666666;
    padding:.4rem;
    border-radius: .2rem;
    header {
        h3 {
            padding-bottom:.2rem;
            text-align: center;
            font-size: .4rem;
            line-height: 1.7em;
            position: relative;
            &::after {
                content: '';
                position:absolute;
                bottom:0; left:10%;height:1px;
                width:80%;
                border-bottom: 1px solid #e2e2e2;
                transform: scaleY(.5);
            }
        }
    }
    .info {
        margin-top:.2rem;
        line-height: 1.7em;
        padding-top:.1rem;
        max-height: 70vh;
        overflow-y: scroll ;
        p:first-child {text-indent: 2em;}
        position:relative;
        p {
            padding-top:.05rem;
        }
        .tiaokuan {
            color:#F6D106;
        }
        &::after {
            content: "";
            position:absolute; bottom:0;left:0; height:2em; 
            width:100%;
            background-image: linear-gradient( rgba(255,255,255,0), rgba(255,255,255,1));
        }
    }
    footer {
        // border: 1px solid red;
        padding:.8rem 0;
        padding-top:1.2rem;
        position: relative;
        .small {
            position: absolute; top:.2rem; left:0;
            font-size:.8em;
            color:#999999;
            line-height: 2em;
        }
        div {
            // font-size:1.2em;
            float: left; width:50%;text-align: center;
            color:#999999;
            &.active {
                color: #333;
                span {
                    background-color: #F6D106;
                    padding:.2rem .6rem;
                    border-radius: 1rem;
                }
            }
        }
    }
}
</style>